import { observable } from 'mobx'
import { ControllerStoreBase } from 'src/controllers/ControllerStoreBase'
import { persist } from 'mobx-persist'
import { repository } from 'src/jtech/jtech-repository'

export default class NegotiationController extends ControllerStoreBase {
  @persist('object') @observable steepControll = {
    isDisabledContinue: false
  };

  @persist('object') @observable steep1 = {
    invoices: []
  };

  @persist('object') @observable steep2 = {
    dadosForm: {
      installmentQuantity: 0,
      firstInstallmentDue: null,

      interestDiscount: 0,
      fineDiscount: 0,
      correctionDiscount: 0
    }
  };

  @persist('object') @observable steep3 = {
    invoicesDetail: []
  };

  @persist('object') @observable steep4 = {
    dadosForm: {
      legalRepresentative: undefined,
      witnessTwo: undefined,
      witnessOne: undefined,
      observation: undefined
    }
  };

  async saveNegotiation (documentClientId, consumerUnitId) {
    const response = await repository.create('agreementInvoice.gravar', {
      agreementInvoiceType: 50310001,
      invoiceIds: this.getInvoices().map(i => i.id),
      documentClient: documentClientId,
      consumerUnit: consumerUnitId,
      ...this.getDadosForm(),
      ...this.getDadosFormResponsible()
    })
    const pdf = await this.getTermNegotiationPdf(response.idGravado, consumerUnitId)
    await this.clearModalData()
    this.currentStep = 0
    return pdf
  }

  async getTermNegotiationHtml (consumerUnitId) {
    const invoiceIds = this.steep1.invoices.map(i => i.id)
    const { firstInstallmentDue, installmentQuantity } = this.steep2.dadosForm
    const { legalRepresentative, witnessOne, witnessTwo } = this.steep4.dadosForm
    const invoicesDetail = this.steep3.invoicesDetail
    const response = await repository.resolveLogic('agreementInvoice.openTermNegotiationHtml', {
      invoiceIds,
      firstInstallmentDue,
      installmentQuantity,
      legalRepresentative,
      witnessOne,
      witnessTwo,
      consumerUnit: consumerUnitId,
      invoicesDetail
    })
    return response.html
  }

  async getTermNegotiationPdf (agreementInvoice, consumerUnitId) {
    const invoiceIds = this.steep1.invoices.map(i => i.id)
    const { firstInstallmentDue, installmentQuantity } = this.steep2.dadosForm
    const { legalRepresentative, witnessOne, witnessTwo } = this.steep4.dadosForm
    const invoicesDetail = this.steep3.invoicesDetail
    const response = await repository.resolveLogic('agreementInvoice.openTermNegotiationPdf', {
      invoiceIds,
      firstInstallmentDue,
      installmentQuantity,
      legalRepresentative,
      witnessOne,
      witnessTwo,
      consumerUnit: consumerUnitId,
      invoicesDetail,
      agreementInvoice: agreementInvoice
    })
    return response.pdf
  }

  async clearModalData () {
    this.steep1 = {
      invoices: []
    }
    this.steep2 = {
      dadosForm: {
        installmentQuantity: 0,
        firstInstallmentDue: null,

        interestDiscount: 0,
        fineDiscount: 0,
        correctionDiscount: 0
      }
    }
    this.steep3 = {
      invoicesDetail: []
    }
    this.steep4 = {
      dadosForm: {
        legalRepresentative: undefined,
        legalRepresentativeName: undefined,
        witnessTwo: undefined,
        witnessOne: undefined,
        witnessOneName: undefined,
        observation: undefined
      }
    }
  }

  getDisabledContinue () {
    return this.steepControll.isDisabledContinue
  }

  setDisabledContinue (isDisabled) {
    this.steepControll.isDisabledContinue = isDisabled
  }

  static async getAsyncInstance () {
    return await super.construct(new NegotiationController(), true)
  }

  static getInstance () {
    return super.construct(new NegotiationController(), true)
  }

  setInvoices (invoices) {
    this.steep1.invoices = invoices
  }

  getInvoices () {
    return this.steep1.invoices
  }

  setInvoicesDetail (invoicesDetail) {
    this.steep3.invoicesDetail = invoicesDetail
  }

  getInvoicesDetail () {
    return this.steep3.invoicesDetail
  }

  getDadosForm () {
    return this.steep2.dadosForm
  }

  getDadosFormResponsible (dadosForm, clientName, clientId) {
    if (clientName) {
      this.steep4.dadosForm.legalRepresentative = clientId
      this.steep4.dadosForm.legalRepresentativeName = clientName
    }
    if (dadosForm && dadosForm.witnessOneName) {
      this.steep4.dadosForm.witnessOne = dadosForm.witnessOne
      this.steep4.dadosForm.witnessOneName = dadosForm.witnessOneName
    }
    return this.steep4.dadosForm
  }
}
